import common from './common';
import accountInformation from './account-information';

export default {
  common, accountInformation
}
